import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import checkAuthenticated from '@/router/middlewares/checkAuthenticated';
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/projects',
    name: 'ProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-view" */ '../modules/projects/components/ProjectsView'
      ),
    meta: {
      moduleId: 'projectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects/:id',
    name: 'ProjectForm',
    component: () =>
      import(
        /* webpackChunkName: "projects-form" */ '../modules/projects/components/form/ProjectForm'
      ),
    meta: {
      moduleId: 'projectsOverview',
      registries: ['configurations/projects', 'configurations/deviations'],
      preloads: ['system/countries/default'],
    },
    props: true,
    beforeEnter(to, from, next) {
      beforeEnterCheck(to, from, next);

      if (from.name === 'ProjectWorkflow' && from.params?.id === to.params?.id) {
        to.params['ignoreNextSyncAlertOnce'] = true;
      }
    }
  },
  {
    path: '/inquiries',
    name: 'InquiriesView',
    component: () =>
      import(
        /* webpackChunkName: "inquiries-view" */ '@/modules/inquiries/components/InquiriesView'
      ),
    meta: {
      moduleId: 'projectInquiries',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/inquiries/:id',
    name: 'InquiryForm',
    component: () =>
      import(
        /* webpackChunkName: "inquiries-form" */ '@/modules/inquiries/components/InquiryForm'
      ),
    meta: { moduleId: 'projectInquiries' },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/projects-categorytree',
    name: 'ProjectTemplateView',
    component: () =>
      import(
        /* webpackChunkName: "project-template-view" */ '../modules/projects/components/templates/ProjectTemplateView'
      ),
    meta: {
      moduleId: 'projectsCategoryTree',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects-categorytree/:id',
    name: 'ProjectTemplateForm',
    component: () =>
      import(
        /* webpackChunkName: "project-template-form" */ '../modules/projects/components/templates/ProjectTemplateForm'
      ),
    meta: {
      moduleId: 'projectsCategoryTree',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/projectprogress',
    name: 'ProjectProgressView',
    component: () =>
      import(
        /* webpackChunkName: "project-progress-view" */ '../modules/projects/components/project_progress/ProjectProgressView'
      ),
    meta: {
      moduleId: 'projectprogress',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  }
];
